import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CodeInput from '~/shared/CodeInput';
import ajax from '~/util';
import * as S from '~/verify/styles';

const NUM_DIGITS = 6;

const Verify = ({ currentUser, setCurrentUser }) => {

    const [inputs, setInputs] = useState(new Array(NUM_DIGITS).fill(""));
    const [alert, setAlert] = useState({
        state: "HIDDEN",
        msg: ""
    });

    const navigate = useNavigate();

    const handleVerify = async (e) => {
        e.preventDefault();
        const code = inputs.join("");
        await ajax.request('put', `/verify`, { code: code })
            .then(res => {
                if (res.data === "Verification code is incorrect") {
                    setAlert({
                        state: "ERROR",
                        msg: "The code you entered is incorrect"
                    });
                } else if (res.data === "User verified") {
                    setCurrentUser({ ...currentUser, account_verified: true });
                    setAlert({
                        state: "SUCCESS",
                        msg: "Account verified"
                    });
                    navigate('/');
                }
            }).catch(err => {
                console.log(err);
                if (err.response.data === "User is already verified") {
                    setAlert({
                        state: "ERROR",
                        msg: "Your account is already verified"
                    });
                    setCurrentUser({ ...currentUser, account_verified: true });
                    navigate('/');
                } else {
                    setAlert({
                        state: "ERROR",
                        msg: "Failed to verify your account"
                    });
                }
            });
    }

    const handleRequestNewCode = async () => {
        await ajax.request('put', `/verify/new`)
            .then(res => {
                setAlert({
                    state: "SUCCESS",
                    msg: "New code was sent to your email"
                });
            }).catch(err => {
                if (err.response.data === "User is already verified") {
                    setAlert({
                        state: "ERROR",
                        msg: "Your account is already verified"
                    });
                    setCurrentUser({ ...currentUser, account_verified: true });
                    navigate('/');
                } else {
                    console.log(err);
                    setAlert({
                        state: "ERROR",
                        msg: "Failed to send code"
                    });
                }
            });
    }

    return (
        <S.CenterScreenContainer>
            <S.Container>
                <S.Header children="Enter Verification Code" />
                <S.SubHeader children={`We sent a code to ${currentUser.email}`} />
                <CodeInput inputs={inputs} setInputs={setInputs} handleVerify={handleVerify} />
                <S.StyledLink children="Click here to send new code" onClick={handleRequestNewCode}/>
                <S.StyledAlertBox state={alert.state} msg={alert.msg} />
            </S.Container>
        </S.CenterScreenContainer>
    )

}

export default Verify;
